export const FOOTER_MAP = {
  linkLists: [
    {
      header: 'Get Started',
      item: [
        {
          title: 'Windows',
          href: '/windows',
        },
        {
          title: 'Doors',
          href: '/doors',
        },
        {
          title: 'Find a Showroom',
          href: '/showrooms',
        },
      ],
    },
    {
      header: 'Explore',
      item: [
        {
          title: 'Installation Process',
          href: '/windows/services/professional-installation/process',
        },
        {
          title: 'Materials',
          href: '/windows/services/professional-installation/materials',
        },
        {
          title: 'Financing',
          href: '/knowledge-center/financing',
        },
      ],
    },
    {
      header: 'Resources',
      item: [
        {
          title: 'Brochures',
          href: '/knowledge-center/brochures',
        },
        {
          title: 'FAQs',
          href: '/knowledge-center/faqs',
        },
      ],
    },
    {
      header: 'Window Nation',
      item: [
        {
          title: 'Window Nation Cares',
          href: '/about-us/cares',
        },
        {
          title: 'Why Window Nation',
          href: '/about-us/why-window-nation',
        },
        {
          title: 'Careers',
          href: '/about-us/careers',
        },
        {
          title: 'Contact Us',
          href: '/contact-us',
        },
        {
          title: 'Make a Payment',
          href: 'https://payment.windownation.com/',
        },
      ],
    },
  ],
  socialIcons: [
    {
      icon: 'Facebook',
      socialMediaLink: {
        title: 'Facebook',
        href: 'https://www.facebook.com/windownation',
      },
    },
    {
      icon: 'Youtube',
      socialMediaLink: {
        title: 'YouTube',
        href: 'https://www.youtube.com/user/WindowNation',
      },
    },
    {
      icon: 'Linkedin',
      socialMediaLink: {
        title: 'LinkedIn',
        href: 'https://www.linkedin.com/company/windownation',
      },
    },
    {
      icon: 'Instagram',
      socialMediaLink: {
        title: 'Instagram',
        href: 'https://www.instagram.com/windownation/?hl=en',
      },
    },
    {
      icon: 'Pinterest',
      socialMediaLink: {
        title: 'Pinterest',
        href: 'https://www.pinterest.com/windownation/',
      },
    },
  ],
  subfooter: {
    subfooterText:
      'Our licenses: MD MHIC # 124358 | VA # 2705178069 | DC # 420212000037 | DELAWARE # 2013601804 | PA # 104611 | MA HIC #197968  | NJ # 13VH07997100 | RI RIGL #44067 | KS #9641242 | CT HIC #0661044 | WA # WINDONL771PW | OR #249065',
    copyrightLanguage: '© 2024 Window Nation. All Rights Reserved.',
    policies: {
      policyLink: [
        {
          title: 'Terms & Conditions',
          href: '/terms-and-conditions',
        },
        {
          title: 'Privacy Policy',
          href: '/privacy-policy',
        },
        {
          title: 'Accessibility',
          href: '/accessibility',
        },
      ],
    },
  },
};
